/**
 * ISO ("2026-08-25", whatever Flarum's DateTime field serializes) -> the
 * DD.MM.YYYY display format used throughout this extension, not the
 * locale-dependent format Date/Intl would otherwise pick. Deliberately a
 * plain string split, not `new Date(iso)` - a bare "YYYY-MM-DD" string
 * parses as UTC midnight in every browser, which can print the *previous*
 * day once shifted back to a negative-UTC-offset local timezone; splitting
 * the digits directly sidesteps that entirely since nothing here actually
 * needs date arithmetic, just reformatting. Shared by ExhibitionPage and
 * ExhibitionsListPage - both had their own identical dateRange() before.
 */
export default function formatDate(iso) {
  if (!iso) return iso;
  const [year, month, day] = iso.split('-');
  if (!year || !month || !day) return iso;
  return `${day}.${month}.${year}`;
}
flarum.reg.add('champis-exhibitions', 'forum/utils/formatDate', formatDate);